// import React from 'react';
// import { useAuth } from './context/AuthContext';
// import AppShell from './components/AppShell';
// import LoginPage from './pages/login/LoginPage';

// const App = () => {
//    //const navigate = useNavigate();
//   const { user } = useAuth();
//   return user ? <AppShell /> : <LoginPage />;



// };

// export default App;


import React, { useState, useEffect } from 'react';
import { useAuth } from './context/AuthContext';
import AppShell from './components/AppShell';
import LoginPage from './pages/login/LoginPage';
import LandingPage from './components/LandingPage';
import BillingModule from './components/BillingModule/BillingModule';
import api from './api/api';
import { mockApiData, fakeApiCall } from './components/data/mockData';

function App() {
  const { user } = useAuth();

  const [transactions, setTransactions] = useState([]);
  const [currentView, setCurrentView] = useState('list'); // 'list' or 'form'
  const [selectedTransaction, setSelectedTransaction] = useState(null);

  const [txnTypes, setTxnTypes] = useState([]);
  const [selectedTxnTypeId, setSelectedTxnTypeId] = useState('');
  const [loadingTxnTypes, setLoadingTxnTypes] = useState(false);
  const [errorTxnTypes, setErrorTxnTypes] = useState(null);

  useEffect(() => {
    fakeApiCall(mockApiData.transactions).then((data) => setTransactions(data));
  }, []);

  useEffect(() => {
    if (!user) return;
    setLoadingTxnTypes(true);
    api.getTxnTypes(user)
      .then((data) => {
        const mapped = data?.Table?.map((item, index) => ({
          id: index + 1,
          name: item.DocTypeName,
        })) || [];
        setTxnTypes(mapped);
      })
      .catch((err) => {
        console.error('Error fetching txn types:', err);
        setErrorTxnTypes(err.message);
      })
      .finally(() => setLoadingTxnTypes(false));
  }, [user]);

  const handleSelectTransaction = (id) => {
    const txn = transactions.find((t) => t.id === id);
    setSelectedTransaction(txn);
    setCurrentView('form');
  };

  const handleCreateNew = () => {
    setSelectedTransaction(null);
    setCurrentView('form');
  };

  const handleBackToList = () => {
    setSelectedTransaction(null);
    setCurrentView('list');
  };

  if (!user) return <LoginPage />;

  return (
    <AppShell>
      {currentView === 'list' ? (
        <LandingPage
          transactions={transactions}
          onSelectTransaction={handleSelectTransaction}
          onCreateNew={handleCreateNew}
        />
      ) : (
        <BillingModule
          initialData={selectedTransaction}
          onBackToList={handleBackToList}
          txnTypes={txnTypes}
          selectedTxnTypeId={selectedTxnTypeId}
          setSelectedTxnTypeId={setSelectedTxnTypeId}
          loadingTxnTypes={loadingTxnTypes}
          errorTxnTypes={errorTxnTypes}
        />
      )}
    </AppShell>
  );
}

export default App;